import type { ClientAccount, Quote, VideoTestimonial } from './schema'

export const proofPage = {
  eyebrow: 'Testimonials',
  titleThin: 'Clients on',
  titleBold: 'what changed.',
  bands: { videos: 'On camera', quotes: 'In writing', clients: 'Client accounts' },
  lede: 'A client in their own words, and the HighLevel accounts I set up, automate or support for coaches, agencies and e-commerce brands in Australia and the US.',
}

const GHL_LOGO = { src: '/images/tools/gohighlevel.png', alt: '', width: 64, height: 64 }

/** The HighLevel accounts from v1's client ledger. Three carry v1's day-to-day description; the other
 *  two were listed by name, type and country only, so their line says no more than that. */
export const clientAccounts: ClientAccount[] = [
  {
    label: 'Nirvana Health',
    role: 'Health coach · Australia',
    work: 'CRM, workflows and email nurture inside their HighLevel account, kept running day to day.',
    tags: ['CRM', 'Workflows', 'Email'],
    logo: GHL_LOGO,
  },
  {
    label: 'Aiorbye',
    role: 'AI consulting agency · United States',
    work: 'Their website and the automations behind it, built and maintained in HighLevel.',
    tags: ['Website', 'Automations'],
    logo: GHL_LOGO,
  },
  {
    label: 'JLS',
    role: 'Business coach (dental) · Australia',
    work: 'Workflows and ongoing support so the coaching pipeline keeps moving without manual chasing.',
    tags: ['Workflows', 'Support'],
    logo: GHL_LOGO,
  },
  {
    label: 'Optimoil',
    role: 'E-commerce · Australia',
    work: 'A HighLevel account I have set up, automated or supported.',
    tags: ['HighLevel'],
    logo: GHL_LOGO,
  },
  {
    label: 'The Breath Movement',
    role: 'Health coach · Australia',
    work: 'A HighLevel account I have set up, automated or supported.',
    tags: ['HighLevel'],
    logo: GHL_LOGO,
  },
]

export const videoTestimonials: VideoTestimonial[] = [
  {
    id: 'jtps-reel',
    src: '/media/jtps-reel.mp4',
    poster: '/media/jtps-reel-poster.jpg',
    width: 720,
    height: 1280,
    duration: '0:27',
    label: 'JTPS testimonial',
    published: '2026-10-03',
  },
]

/** Written feedback. Only named, dated quotes are used; v1 had none, so the band is not shown. */
export const communityQuotes: Quote[] = []
